import { render, staticRenderFns } from "./BankConfigureCtepBankTypePerBrandSettings.vue?vue&type=template&id=07961481"
import script from "./BankConfigureCtepBankTypePerBrandSettings.vue?vue&type=script&lang=ts"
export * from "./BankConfigureCtepBankTypePerBrandSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07961481')) {
      api.createRecord('07961481', component.options)
    } else {
      api.reload('07961481', component.options)
    }
    module.hot.accept("./BankConfigureCtepBankTypePerBrandSettings.vue?vue&type=template&id=07961481", function () {
      api.rerender('07961481', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/BankConfigureCtepBankTypePerBrandSettings.vue"
export default component.exports